import React, { useEffect, useState } from 'react';
import { baseUrl } from '../../../../../../constants/constants';
import { dwnldForums } from '../../../../../../components/excel-export/excel-export';
import BlankForum from './BlankForum';
import { Link } from 'react-router-dom';

export interface IBlankForum {
    id: number;
    email: string;
    full_name: string;
    full_name_declination: string;
    age: number;
    number_phone: string;
    region_residence: string;
    place_of_work: string;
    position_work: string;
    travel_certificate: boolean;
    forum_id: number;
    visit_format: {
        id: number;
        name: string;
    };
    forum: {
        id: number;
        name: string;
    };
    date_creation: Date;
    questions: string;
    is_approved: boolean;
}

export interface IForum {
    id: number;
    name: string;
}

const ForumTable = () => {
    const pageSize = 10;

    const [forums, setForums] = useState<IForum[]>([]);
    const [forumsData, setForumsData] = useState<Record<number, {
        items: IBlankForum[];
        displayCount: number;
        hasMore: boolean;
        loading: boolean;
    }>>({});
    const [loadedForums, setLoadedForums] = useState<Record<number, boolean>>({});

    // Загрузка списка форумов
    useEffect(() => {
        fetch(`${baseUrl}forum`)
            .then(res => {
                if (!res.ok) throw new Error(`Ошибка сети: ${res.status}`);
                return res.json();
            })
            .then((data: IForum[]) => {
                console.log("Полученные форумы:", data);
                setForums(data);

                const initialData = data.reduce((acc, forum) => {
                    acc[forum.id] = {
                        items: [],
                        displayCount: 10,
                        hasMore: true,
                        loading: false
                    };
                    return acc;
                }, {} as Record<number, {
                    items: IBlankForum[],
                    displayCount: number,
                    hasMore: boolean,
                    loading: boolean
                }>);

                setForumsData(initialData);
            })
            .catch(err => {
                console.error('Ошибка при загрузке форумов:', err);
            });
    }, []);

    // Запуск первой загрузки заявок после инициализации forumsData
    useEffect(() => {
        if (Object.keys(forumsData).length > 0 && Object.keys(loadedForums).length === 0) {
            Object.keys(forumsData).forEach(forum_id => {
                const id = Number(forum_id);
                fetchForumBlanks(id, 1, true); // reset = true
                setLoadedForums(prev => ({ ...prev, [id]: true }));
            });
        }
    }, [forumsData]);

    // Функция загрузки заявок для конкретного форума
    const fetchForumBlanks = (forum_id: number, page: number, reset = false) => {
        const current = forumsData[forum_id];

        if (!current || current.loading || (!reset && !current.hasMore)) return;

        setForumsData(prev => ({
            ...prev,
            [forum_id]: {
                ...prev[forum_id],
                loading: true
            }
        }));

        fetch(`${baseUrl}blank_forum?sort_date=true&page=${page}&page_size=${pageSize}&forum_id=${forum_id}`)
            .then(res => {
                if (!res.ok) throw new Error(`Ошибка сети: ${res.status}`);
                return res.json();
            })
            .then((data: IBlankForum[]) => {
                setForumsData(prev => ({
                    ...prev,
                    [forum_id]: {
                        items: reset ? data : [...prev[forum_id].items, ...data],
                        displayCount: reset ? data.length : prev[forum_id].displayCount + data.length,
                        hasMore: data.length === pageSize,
                        loading: false
                    }
                }));
            })
            .catch(err => {
                console.error(`Ошибка при загрузке заявок для форума ${forum_id}:`, err);
                setForumsData(prev => ({
                    ...prev,
                    [forum_id]: {
                        ...prev[forum_id],
                        loading: false
                    }
                }));
            });
    };

    // Обработчик нажатия на "Больше"
    const handleLoadMore = (forum_id: number) => {
        const current = forumsData[forum_id];
        const nextPage = Math.floor(current.displayCount / pageSize) + 1;
        fetchForumBlanks(forum_id, nextPage);
    };

    return (
        <section className="admin-section">
            <h1 className="admin-title__h1-media">Редактирование секции "Заявки"</h1>
            <section className="admin-media__btns-section">
                <Link to='#'>
                    <button className="button admin-media__btn-active">Форумы</button>
                </Link>
                <Link to='/admin-panel/applications/online'>
                    <button className="button admin-media__btn">Онлайн-курсы</button>
                </Link>
                <Link to='/admin-panel/applications/obzor'>
                    <button className="button admin-media__btn">Обзор.НЦПТИ</button>
                </Link>
            </section>

            {forums.map(forum => {
                const data = forumsData[forum.id];
                const displayedItems = data.items.slice(0, data.displayCount);

                return (
                    <div key={forum.id} className="one-table">
                        <div className="admin-buttons">
                            <h3 className='admin-title__h3'>{forum.name}</h3>
                            <button
                                className="button admin-btn"
                                onClick={() => dwnldForums(forum.id)}
                            >
                                Excel
                            </button>
                        </div>

                        <table className='applications-table'>
                            <thead className='applications-table__thead'>
                            <tr>
                                <th className='applications-table__thead-th'>Email</th>
                                <th className='applications-table__thead-th'>Имя</th>
                                <th className='applications-table__thead-th'>Телефон</th>
                                <th className='applications-table__thead-th'>Регион</th>
                                <th className='applications-table__thead-th'>Место работы</th>
                                <th className='applications-table__thead-th'>Должность</th>
                                <th className='applications-table__thead-th'>Командировочное</th>
                                <th className='applications-table__thead-th'>Формат форума</th>
                                <th className='applications-table__thead-th'>Дата подачи</th>
                            </tr>
                            </thead>
                            <tbody className='applications-table__tbody'>
                            {displayedItems.length > 0 ? (
                                displayedItems.map(item => (
                                    <BlankForum
                                        key={item.id}
                                        {...item}
                                        onUpdate={() => fetchForumBlanks(forum.id, 1, true)}
                                    />
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={12} style={{ textAlign: 'center' }}>
                                        {data.loading ? 'Загрузка...' : 'Заявок пока нет'}
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>

                        {!data.loading && data.hasMore && (
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                <button
                                    className="button admin-btn"
                                    onClick={() => handleLoadMore(forum.id)}
                                >
                                    Больше
                                </button>
                            </div>
                        )}

                        {data.loading && (
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                Загрузка...
                            </div>
                        )}
                    </div>
                );
            })}
        </section>
    );
};

export default ForumTable;

// import React, {useEffect, useState} from 'react';
// import {baseUrl} from "../../../../../../constants/constants";
// import {dwnldForums} from "../../../../../../components/excel-export/excel-export";
// import BlankForum from "./BlankForum";
// import {Link} from "react-router-dom";
// import {IForum} from "../../../ForumsSettingsPage/ForumsSettingsPage";
//
// export interface IBlankForum {
//     id: number,
//     email: string,
//     full_name: string,
//     full_name_declination: string,
//     age: number,
//     number_phone: string,
//     region_residence: string,
//     place_of_work: string,
//     position_work: string,
//     travel_certificate: boolean,
//     forum_id: number,
//     visit_format: {
//         id: 0,
//         name: string,
//     },
//     forum: {
//         id: number,
//         name: string
//     }
//     date_creation: Date,
//     questions: string,
//     is_approved: boolean,
// }
//
// export interface IForumId{
//     forumId: IForum
// }
//
// const ForumTable = () => {
//     const [forumBlanks, setForumBlanks] = useState<IBlankForum[]>([]);
//     const[forumId, setForumId] = useState<IForumId>()
//     const pageSize = 10;
//     const [currentPage, setCurrentPage] = useState(1)
//     const [disabled, setDisabled] = useState(false)
//
//     useEffect(() => {
//         fetch(`${baseUrl}forum`)
//             .then((res) => res.json())
//             .then((data) => setForumId(data))
//     }, []);
//
//     const fetchForumBlanks = () => {
//         fetch(`${baseUrl}blank_forum?sort_date=true&page=${currentPage}&page_size=${pageSize}`)
//             .then((res) => res.json())
//             .then((data) => {
//                 setForumBlanks(data)
//             })
//             .catch((err) => {
//             });
//     }
//
//     useEffect(() => {
//         fetchForumBlanks()
//     }, []);
//
//     return (
//             <section className="admin-section">
//                 <h1 className="admin-title__h1-media">Редактирование секции "Заявки"</h1>
//                 <section className="admin-media__btns-section">
//                     <Link to='#'>
//                         <button className="button admin-media__btn-active">Форумы</button>
//                     </Link>
//                     <Link to='/admin-panel/applications/online'>
//                         <button className="button admin-media__btn">Онлайн-курсы</button>
//                     </Link>
//                     <Link to='/admin-panel/applications/obzor'>
//                         <button className="button admin-media__btn">Обзор.НЦПТИ</button>
//                     </Link>
//                 </section>
//              <div className="one-table">
//             <div className="admin-buttons">
//                 <h3 className='admin-title__h3'>Форумы</h3>
//                 <button className="button admin-btn" onClick={() => {
//                     dwnldForums(forumBlanks[0]?.forum.id || 1);
//                 }}>Excel
//                 </button>
//             </div>
//             <table className='applications-table'>
//                 <thead className='applications-table__thead'>
//                 <tr>
//                     <th className='applications-table__thead-th'>Название форума</th>
//                     <th className='applications-table__thead-th'>Email</th>
//                     <th className='applications-table__thead-th'>Имя</th>
//                     <th className='applications-table__thead-th'>Имя в родительном падеже</th>
//                     <th className='applications-table__thead-th'>Возраст</th>
//                     <th className='applications-table__thead-th'>Телефон</th>
//                     <th className='applications-table__thead-th'>Регион</th>
//                     <th className='applications-table__thead-th'>Место работы</th>
//                     <th className='applications-table__thead-th'>Должность</th>
//                     <th className='applications-table__thead-th'>Командировочное</th>
//                     <th className='applications-table__thead-th'>Формат форума</th>
//                     <th className='applications-table__thead-th'>Дата подачи</th>
//                 </tr>
//                 </thead>
//                 {forumBlanks.map((item) =>
//                     <tbody className='applications-table__tbody' key={item.id}>
//                     <BlankForum
//                         {...item}
//                         onUpdate={fetchForumBlanks}
//                     />
//                     </tbody>
//                 )}
//             </table>
//         </div>
//     </section>
//     );
// };
//
// export default ForumTable;